import React from "react";

import './CallUsButton.css';

const CallUsButton = props => {
    const cellphone = "8883701687";
    const handleButtonClick = () => {
        window.location.href = `tel:${cellphone}`;
      };
    return(
   
         <button className="call-us-button" onClick={handleButtonClick}>
        {props.phonenumber}
        </button>
   
    );
};

export default CallUsButton;